import { useEffect } from "react";

/* Per-page SEO: client-side title/meta/OG/canonical/JSON-LD manager.
   The static index.html only carries site-wide defaults — this hook rewrites
   them per page (Google renders JS and picks these up) and restores the
   defaults on unmount. Crawlers that don't run JS are served the
   server-rendered share cards (/api/share/...) instead. */

const DEFAULT_TITLE = "Solis Casting — Fashion Model Casting";
const DEFAULT_DESC = "Solis Casting — the casting venue. Where houses, magazines and brands meet their next face.";
const DEFAULT_IMAGE = `${typeof window !== "undefined" ? window.location.origin : ""}/og-red-code.jpg`;

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function applyAll(t, d, img, u, noindex) {
  document.title = t;
  upsertMeta("name", "description", d);
  upsertMeta("property", "og:title", t);
  upsertMeta("property", "og:description", d);
  upsertMeta("property", "og:url", u);
  upsertMeta("property", "og:image", img);
  upsertMeta("name", "twitter:title", t);
  upsertMeta("name", "twitter:description", d);
  upsertMeta("name", "twitter:image", img);
  let robots = document.head.querySelector('meta[name="robots"]');
  if (noindex) {
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, nofollow");
  } else if (robots) {
    robots.remove();
  }
}

export function usePageMeta({ title, description, image, url, jsonLd, noindex } = {}) {
  const ldKey = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (!title) return undefined;
    const t = title;
    const d = description || DEFAULT_DESC;
    const img = image || DEFAULT_IMAGE;
    const u = url || window.location.href;
    applyAll(t, d, img, u, noindex);

    const canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    canonical.setAttribute("href", u);
    canonical.setAttribute("data-page-seo", "1");
    document.head.appendChild(canonical);

    let ld = null;
    if (ldKey) {
      ld = document.createElement("script");
      ld.setAttribute("type", "application/ld+json");
      ld.setAttribute("data-page-seo", "1");
      ld.textContent = ldKey;
      document.head.appendChild(ld);
    }

    return () => {
      applyAll(DEFAULT_TITLE, DEFAULT_DESC, DEFAULT_IMAGE, `${window.location.origin}/`, false);
      canonical.remove();
      ld?.remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, image, url, ldKey, noindex]);
}
